import { Table, TableBody, TableHead } from '@material-ui/core'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { EerResultsTableRow } from './EerResultsTableRow'
import { energyPerAreaUnit } from '../../util/formatters'
import { purchasedEnergySubCategories } from '../../provider/result-categories'
import { CalculatedVersion } from '../../calculators/use-calculator'
import { ResultsTableHeaderRow } from '../common/ResultsTableHeaderRow'

type Props = {
  versions: CalculatedVersion[]
}

export function EerResultsTable({ versions }: Props): React.ReactElement {
  const { t } = useTranslation()
  return (
    <Table>
      <TableHead>
        <ResultsTableHeaderRow
          title=""
          values={versions.map((version) => version.name)}
        />
      </TableHead>
      <TableBody>
        <EerResultsTableRow
          title={t('eer.resultsTable.preciseEer')}
          versions={versions}
          purchasedEnergySubCategories={purchasedEnergySubCategories}
          increasePrecision
        />
        <EerResultsTableRow
          title={`${t('eer.resultsTable.eer')}, ${energyPerAreaUnit}`}
          versions={versions}
          purchasedEnergySubCategories={purchasedEnergySubCategories}
        />
      </TableBody>
    </Table>
  )
}
